import React from "react";
import Select from "react-select";

export type SearchableOption = { value: string | number; label: string };

interface Props {
  options: SearchableOption[];
  value?: string | number | null;
  onChange: (value: string | number | null) => void;
  placeholder?: string;
  isDisabled?: boolean;
  isClearable?: boolean;
}

const findOption = (options: SearchableOption[], value?: string | number | null) => {
  if (value === undefined || value === null || value === "") return null;
  return options.find((o) => String(o.value) === String(value)) || null;
};

const SearchableSelect = ({
  options,
  value,
  onChange,
  placeholder = "Type to search",
  isDisabled = false,
  isClearable = true,
}: Props) => {
  return (
    <Select
      className="react-select-container"
      classNamePrefix="react-select"
      isSearchable
      isClearable={isClearable}
      isDisabled={isDisabled}
      options={options}
      value={findOption(options, value)}
      placeholder={placeholder}
      onChange={(option) => onChange(option ? option.value : null)}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
      menuShouldScrollIntoView={false}
      menuShouldBlockScroll={false}
      closeMenuOnSelect
      blurInputOnSelect={false}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999, pointerEvents: "auto" }),
        menu: (base) => ({ ...base, zIndex: 9999, pointerEvents: "auto" }),
        option: (base) => ({ ...base, cursor: "pointer", pointerEvents: "auto" }),
        control: (base, state) => ({
          ...base,
          minHeight: 52,
          background: "var(--dashboard-bg)",
          borderColor: state.isFocused ? "var(--primary-dark)" : "var(--grayscale-line)",
          boxShadow: "none",
          "&:hover": { borderColor: "var(--primary-dark)" },
        }),
      }}
    />
  );
};

export default React.memo(SearchableSelect);
